export default __webpack_public_path__ + "static/media/Destiny.13b006b7.mp3";